import { setStoreProductsAction as setStoreProductsOperation } from 'editor/src/store/mockup/slice';

export default setStoreProductsOperation;
